import { Injectable, inject } from '@angular/core';
import { API } from '@aws-amplify/api';
import { NbToastrService } from '@nebular/theme';
import { Store } from '@ngxs/store';
import { Observable } from 'rxjs';
import { RouterState } from 'src/app/features/auth/redux/router-state';
import { Robot } from 'src/app/models/robot';
import { APIS } from 'src/app/shared/constants/api-constants';
import { ToggleHide } from 'src/app/shared/ui/spinner/redux/spinner.actions';
import { ENVIRONMENT } from 'src/environments/environment';
import {
  DeleteRobotsSuccess,
  LoadOwnerRobotsSuccess,
  LoadRobotsSuccess,
  SaveRobotComplete,
  SaveRobotFail
} from '../redux/qa.actions';

@Injectable({
  providedIn: 'any'
})
export class RobotsService {
  public username$: Observable<string> = inject(Store).select(RouterState.username);

  public owner: string;
  public robots_api = APIS.ROBOTS;

  constructor(
    private store: Store,
    private toastrService: NbToastrService
  ) {
    this.username$.subscribe((data) => (this.owner = data));
  }

  public loadAllRobotsAmplify(reload?) {
    API.get(this.robots_api, `/${ENVIRONMENT.name}/insights/qa/robots`, {})
      .then((response) => {
        if (reload) {
          this.toastrService.show(status, 'Fetching Robots Complete', {
            status: 'info'
          });
        }
        this.store.dispatch(new LoadRobotsSuccess(response));
      })
      .catch((error) => {
        this.store.dispatch(ToggleHide);
        this.toastrService.show(status, 'Failed to fetch robot list', { status: 'danger' });
        console.error('Error occured', error);
      });
  }

  public postRobotAmplify(newRobot: Robot, isEdit?: boolean) {
    API.post(this.robots_api, `/${ENVIRONMENT.name}/insights/qa/robots`, { body: newRobot })
      .then(() => {
        this.store.dispatch(new SaveRobotComplete(isEdit, newRobot));
      })
      .catch((error) => {
        this.store.dispatch(new SaveRobotFail(error));
      });
  }

  public deleteRobotAmplify(robot: Robot) {
    API.del(this.robots_api, `/${ENVIRONMENT.name}/insights/qa/robots`, { body: robot })
      .then(() => {
        this.store.dispatch(new DeleteRobotsSuccess(robot));
      })
      .catch((error) => {
        this.store.dispatch(new SaveRobotFail(error));
      });
  }

  public loadOwnerRobotsAmplify() {
    API.get(this.robots_api, `/${ENVIRONMENT.name}/insights/qa/robots`, {
      queryStringParameters: { owner: this.owner }
    })
      .then((response) => {
        this.toastrService.show(status, 'Fetch owner robots complete', { status: 'success' });
        this.store.dispatch(new LoadOwnerRobotsSuccess(response));
      })
      .catch((error) => {
        this.toastrService.show(status, 'Failed to fetch owner robots', { status: 'danger' });
        this.store.dispatch(ToggleHide);
        console.error('Error occured', error);
      });
  }
}
